import { FIELD_TYPES_SELECT_OPTIONS } from '../constants';

export const disableSelectOptions = (fieldName: string) => {
  // check if fieldName has period
  const regex = /\./g;
  if (regex.test(fieldName)) {
    return FIELD_TYPES_SELECT_OPTIONS.map((o) =>
      o.value === 'object' ? { ...o, disabled: true } : o,
    );
  }
  return FIELD_TYPES_SELECT_OPTIONS;
};
